import React from 'react';
import { Box } from '@mui/material';

import { ConfigSection } from '../../../common';
import { useMerchant } from '../../../contexts/MerchantContext';
import { useGetAgenticSettingsQuery } from '../../../store/modules/merchant/api';
import { CatalogSyncReadinessNotice } from '../components/CatalogSyncReadinessNotice';
import { CatalogSyncButton } from '../components/CatalogSyncButton';

const CATALOG_DESCRIPTION_MAX_WIDTH = 700;

/**
 * Operator view over the product catalog backing the shopping agent's search
 */
export const CatalogTab = (): JSX.Element => {
  const { merchantId } = useMerchant();
  const { data: agenticSettings } = useGetAgenticSettingsQuery(merchantId, {
    skip: !merchantId,
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  });

  return (
    <Box
      data-testid="ella-catalog-tab"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      <CatalogSyncReadinessNotice storeReadiness={agenticSettings?.storeReadiness} />

      <ConfigSection
        title="Catalog sync"
        description="Re-ingest the merchant's full product catalog so the shopping agent searches current data. Large catalogs can take several minutes to finish."
        sx={{ maxWidth: CATALOG_DESCRIPTION_MAX_WIDTH }}
      >
        <CatalogSyncButton />
      </ConfigSection>
    </Box>
  );
};
